<template>
  <div class="my_collect_topic" >
    <div class="list_wrap">
      <List v-model="loading" :finished="finished" @load="loadMore" finished-text="It's the end~"> 
        <div class="noissue_item" v-for="(item,index) in list" :key="index" @click="LinkToHotDetails(item.id)">
          <img v-if="item.logoUrl" :src="item.logoUrl" v-load="'oPic'" >
          <img v-else src="@/assets/img/empty.png" >
          <div class="noissue_info">
            <div class="info_title">#{{item.title}}#</div>
            <div class="info_brief">{{item.summary}}</div>
            <div class="info_count">
              <span>阅读数：{{wCount(item.viewCount)}}</span>
              <span>讨论数：{{wCount(item.talkCount)}}</span>
            </div>
            <div class="info_user">发起人：{{item.publisherName}}</div>

          </div>
          <div class="like_btn"  @click.stop="cancelLike(item.id)">已关注</div>
        </div>
        <div slot="loading" class="f-tac loading">
          <img src="@assets/img/new/icon-loading.png" />
          loading...
        </div>
        <div slot="finished" class="f-tac loading">It's the end~</div>
      </List>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { List } from "vant";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
export default {  
  name: "my-collect-topic",
  data() {
    return {
      loading: false,   //我联系的加载状态
      finished: false,  //我联系的是否完成状态
      list: [],         //我联系的列表
      pageIndex: 0,
      pageSize:20,
      queryThemeFollow:{},
    };
  },
  components: { List },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      exhibitionId:"getExhibitionId"
    }),
  },
  created() {
  },
  methods: {
    ...mapActions({
      LinkToHotDetails:'linkTo/LinkToHotDetails',
      delFollowerTopic:'follower/delFollowerTopic'
    }),
     wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    getList(){
      let query=gql`
      query queryThemeFollow($query:QueryInput!,$exhibitionId:Guid!,$memberId:Guid!){
        queryThemeFollow(query:$query,exhibitionId:$exhibitionId){
          hasNextPage
          indexFrom
          pageIndex
          pageSize
          items{
            theme{
              content
              createAt
              id
              isFollow(memberId:$memberId)
              logoUrl
              publisherName
              talkCount
              title
              viewCount
            }
          }
        }
      }`
      let where={
        "Equal":{
          "n":"memberId",
          "v":this.userInfo.inMember.memberId
        },
        // "EqualB":{
        //   "n":"exhibitionId",
        //   "v":this.exhibitionId
        // }
      }
      let order=[
        {
          "N":"createAt",
          "v":0
        }
      ]
      let opt={
        page:this.pageIndex,
        size:this.pageSize,
        where:JSON.stringify(where),
        order:JSON.stringify(order)
      }
      this.$apollo.addSmartQuery("queryThemeFollow",{ 
        query:query,
        variables:{
         query:opt,
         exhibitionId:this.exhibitionId,
         memberId:this.userInfo.inMember.memberId
        },
        fetchPolicy: 'network-only',    //清理缓存
        result(data){
          this.finished=true;
          this.loading=false;
          let res=JSON.parse(JSON.stringify(data.data.queryThemeFollow));
          // let res=data.data.queryProduct;
          console.log('话题关注',res);
          let items=[];
          if(res.items.length){
            res.items.forEach(el => {
              if(el.theme){
                items.push(el.theme)
              }
            });
          }
          items.forEach(e=>{
              e.createAt=moment(e.createAt).format('YYYY/MM/DD HH:mm:ss');
              if(e.imgUrls){
                e.imgUrls= e.imgUrls.split(';');
              }
          })
          if(this.pageIndex==1){
            this.list=items
          }else{
            this.list=[...new Set([...this.list,...items])];
          }
          this.loading=false;
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.loading=false;
          this.finished = true;
          console.log('err',err)
        }
      })
      // setTimeout(()=>{
      //   this.list=[...this.list,...this.list];
      //   this.loading=false;
      //   if(this.list.length>20){
      //     this.finished=true
      //   }
      // },1000)
    },
    loadMore(){
      if(this.finished) return;
      this.pageIndex+=1;
      this.getList();
    },
    //取消关注
    async cancelLike(id){
      let opt={
        themeId:id,
        memberId:this.userInfo.inMember.memberId
      }
      let res= await this.delFollowerTopic(opt);
      if(res&&res.result){
        this.list=this.list.filter(item => item.id!=id);
        this.$toast.success("取消关注");
      }else{
        this.$toast.fail('取消失败')
      }
    }
  }
};
</script>

<style scoped lang="scss">
//展品列表
.my_collect_topic{
  .list_wrap{
    .noissue_item{
        height: 2rem;
        box-sizing: border-box;
        padding: 0.2rem;
        background-color: #fff;
        border-radius: 0.05rem;
        display: flex;
        margin-bottom: 0.3rem;
        position: relative;
        .like_btn{
          position: absolute;
          bottom: 0.2rem;
          right: 0.2rem;
          height: 0.48rem;
          width: 1.1rem;
          border: solid 1px #ff5c00;
          border-radius: 0.26rem;
          color: #ff5c00;
          box-sizing: border-box;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        &:last-child{
          margin-bottom: 0;
        }
        img{
          flex-shrink: 0;
          width: 1.6rem;
          height: 1.6rem;
          border-radius: 0.05rem;
          display: block;
        }
        .noissue_info{
          width: calc(100% - 1.8rem);
          margin-left: 0.2rem;
          color: #666;
          font-size: 0.2rem;
          display: flex;
          flex-direction: column;
          div{
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .info_title{
            font-size: 0.26rem;
            color: #333;

          }
          .info_brief{
            margin-top:0.05rem;
          }
          .info_count{
            margin-top: 0.2rem;
            span{
              margin-right: 0.3rem;
              &:last-child{
                margin-right: 0;
              }
            }
          }
          .info_count,.info_user{
            max-width: calc(100% - 1.1rem);
          }
          .info_user{
            margin-top: auto;
            color: #333;
          }
        }
      }
  }
}
.f-tac {
  text-align: center;
}
.loading {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 18px;
    height: 18px;
    display: inline-block;
    margin-right: 5px;
    animation: 1s loader-01 linear infinite;
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
